import { Component, OnInit, ViewChild } from '@angular/core';
import { InstitutionType } from '@app/models/institution';
import { Subscription } from 'rxjs';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { FormBuilder } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { SortService } from '@app/components/sorting/SortService';
import { ActivatedRoute } from '@angular/router';
import { PdfService } from '@app/services/pdf/pdf.service';
import { PlatformLocation } from '@angular/common';


interface District {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

@Component({
  selector: 'app-lillamatrikeln',
  templateUrl: './lillamatrikeln.component.html',
  styleUrls: ['./lillamatrikeln.component.css']
})
export class LillamatrikelnComponent implements OnInit {
  subscriptions: Subscription[] = [];
  institutiontypes: InstitutionType[] = [];
  districtlist: District[] = [];
  @ViewChild('contentToConvert', { static: true }) content;
  matrikelform;
  
  timestamp;
  data;
  constructor(private institutionService: InstitutionsService, private pdfService: PdfService,  private location: PlatformLocation, private route: ActivatedRoute, private memberService: MemberService, private fb: FormBuilder) { }

  ngOnInit() {
    this.matrikelform = this.fb.group({
      institutionTypeId: ['', ''],
      institutionNumber: ['', ''],
      institutionName: ['', ''],
      visitingCity: ['', ''],
      districtId: ['', ''],
    });
    this.route.params.subscribe(p => {
      if (p) {

        this.getInstitution(p.id);
      }
    });
    this.getInstitutionTypes();
    this.getAllDistricts();
  }

  getInstitution(id) {
    this.institutionService.getInstitutionByIdAsync(id).subscribe(i => {

      this.matrikelform.patchValue({institutionTypeId: i.institutionTypeId.toString()});
      this.matrikelform.patchValue({institutionNumber: i.institutionNumber.toString()});
      this.search();
    });
  }

  getInstitutionTypes() {
    this.subscriptions.push(this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
    }));
  }

  getAllDistricts() {
    this.memberService.getAllDistricts(0).subscribe(response => {
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  goBack() {
    this.location.back();
  }

  search() {
    this.timestamp = new Date();

    const smallMatrixInput = this.matrikelform.value;

    this.memberService.GetSmallMatrix(smallMatrixInput).subscribe(response => {

      this.data = response[0];

    });
  }

  clear() {
    this.matrikelform?.reset();
  }

  captureScreen() {

    this.pdfService.captureScreen(this.content, 'p', null);
   // this.router.navigate(['/memberform/id/', this.memberid]);
   }
}
